import * as types from "./types";

export const RoleInitialState = {
  //get request for all role
  allRole: [],
  allRoleLoading: false,
  allRoleError: null,

  

  // post request
  postRoleLoading: false,
  postRoleError: null,
};

export const roleReducer = (state = RoleInitialState, action: any) => {
  switch (action.type) {
    case types.POST_ROLE_FETCH_START:
        return {
          ...state,
          postRoleLoading: true,
        };
      case types.POST_ROLE_FETCH_SUCCESS:
        return {
          ...state,
          postRoleLoading: false,
        };
  
      case types.POST_ROLE_FETCH_FAILURE:
        return {
          ...state,
          postRoleError: action.postRoleError,
          postRoleLoading: false,
        };
  

    case types.ALL_ROLE_GET_START:
      return {
        ...state,
        allRoleLoading: true,
      };
    case types.ALL_ROLE_GET_SUCCESS:
      return {
        ...state,
        allRole: action.allRole,
        allRoleLoading: false,
      };
    case types.ALL_ROLE_GET_FINISH:
      return {
        ...state,
        allRoleError: action.allRoleError,
        allRoleLoading: false,
      };

    default:
      return state;
  }
};
